<template>
  <section v-if="data.highlight && data.highlight.status === 'published'"
           class="highlight-article-block">
    <div v-if="marqueeLabel" class="highlight-article-block__inner">
      <LayoutsScrollMarqueeBackground :title="marqueeLabel" :small="true" />
    </div>
    <AppLayoutContainerNarrow :flush="true">
      <AppArticleCard
          heading="h2"
          :data="data.highlight"
          :show-reading-time="false"
          class="highlight-article-block__highlight-block"
      />
    </AppLayoutContainerNarrow>
  </section>
</template>

<script setup lang="ts">
import {computed} from 'vue'
import {THighlightArticleBlock} from '~/types/block-types'
import {sanitizeMarkedHeading} from "#imports";

const props = defineProps<{
  data: THighlightArticleBlock,
}>()

const marqueeLabel = computed(() => {
  return sanitizeMarkedHeading(props.data.highlight?.belongs_to[0]?.item?.title)
})
</script>

<style scoped lang="postcss">
.highlight-article-block {
  position: relative;
  padding-top: 1rem;
  padding-bottom: 1rem;
  @mixin app-block-margins;

  @media (--md) {
    padding-top: 48px;
    padding-bottom: 48px;
  }

  @media (--lg) {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  &__inner {
    position: absolute;
    left: 0px;
    top: 50%;
    z-index: -1;
    width: 100%;
    transform: translateY(-50%);
  }

  &__highlight-block {
    padding-left: 1.5rem;
    padding-right: 1.5rem;

    @media (--sm) {
      padding-left: 0px;
      padding-right: 0px;
    }

    @media (--md) {
      margin-left: -1.25rem;
      margin-right: -1.25rem;
    }

    @media (--lg) {
      margin-left: 0px;
      margin-right: 0px;
    }
  }
}
</style>
